import { FC } from "react";
import { styled } from "styled-components";
import { FormattedCategory } from "./CategoryWrapper";
import { font } from "../lib/sharedStyles";

const Pill = styled.a`
  white-space: nowrap;
  padding: 8px 16px;
  text-align: center;
  border-radius: 100px;
  background: #F7F7F7;
  ${font('Instrument Sans', 600, '14px', '22px')}
  color: #191A1F;
  text-decoration: none;
  letter-spacing: 0.14px;
  transition: background 150ms ease;
  min-width: 210px;
  
  &:hover {
    background: #e5e5e5;
  }

  @media (min-width: 768px) {
    display: block;
    padding: 9px 24px;
  }
`;

const CategoryPill: FC<FormattedCategory> = ({ title, url }) => (
  <Pill href={url}>{title}</Pill>
);

export default CategoryPill;